document.addEventListener('DOMContentLoaded', function () {
    const slickPrevArrow = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0875 13.825L9.27084 10L13.0875 6.175L11.9125 5L6.91251 10L11.9125 15L13.0875 13.825Z" fill="#111827"/></svg>';
    // const slickPrevArrow = '<svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3 11.0004C3 10.6591 3.13999 10.3177 3.41856 10.0577L10.5612 3.39106C11.1197 2.86973 12.0225 2.86973 12.5811 3.39106C13.1396 3.91239 13.1396 4.75506 12.5811 5.27639L6.44845 11.0004L12.5811 16.7244C13.1396 17.2457 13.1396 18.0884 12.5811 18.6097C12.0225 19.1311 11.1197 19.1311 10.5612 18.6097L3.41856 11.9431C3.13999 11.6831 3 11.3417 3 11.0004Z" fill="#1E1F1F" fill-opacity="1"/></svg>';
    const slickNextArrow = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.91248 13.825L10.7291 10L6.91248 6.175L8.08748 5L13.0875 10L8.08748 15L6.91248 13.825Z" fill="#111827"/></svg>';
    // const slickNextArrow = '<svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13 11.0003C13 11.3417 12.86 11.683 12.5814 11.943L5.43884 18.6097C4.88029 19.131 3.97747 19.131 3.41891 18.6097C2.86036 18.0883 2.86036 17.2457 3.41891 16.7243L9.55155 11.0003L3.41891 5.27634C2.86036 4.75501 2.86036 3.91234 3.41891 3.39101C3.97747 2.86967 4.88029 2.86967 5.43884 3.39101L12.5814 10.0577C12.86 10.3177 13 10.659 13 11.0003Z" fill="#1E1F1F"/> </svg>';

    function initAdditionalProductsOnCart(refresh = false) {
        // Slick slider for related products in cart
        let slidesToShow = 3;
        if (document.querySelector('.cart__contents')) {
            slidesToShow = 4;
        }
        let additionalProducts = document.querySelectorAll('.additional-products-cart--items--wrap');
        if (additionalProducts) {
            additionalProducts.forEach((item) => {
                if (!item.className.includes('slick-initialized')) {
                    console.log('init slick');
                    $(item).slick({
                        infinite: true,
                        slidesToShow: slidesToShow,
                        slidesToScroll: 1,
                        dots: false,
                        centerMode: false,
                        prevArrow: '<button type="button" class="slick-prev slick-arrow">' + slickPrevArrow + '</button>',
                        nextArrow: '<button type="button" class="slick-next slick-arrow">' + slickNextArrow + '</button>',
                        responsive: [
                            {
                                breakpoint: 560,
                                settings: {
                                    slidesToShow: 1.25,
                                    centerPadding: '0px',
                                    arrows: false,
                                    centerMode: true,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 2.25,
                                    arrows: false,
                                    centerPadding: '10px'
                                }
                            }
                        ]
                    });
                    $(item).slick('setPosition');
                } else {
                    console.log('refresh');
                    // $(item).slick('reInit');
                    // $(item).slick('refresh');
                    // Manually refresh positioning of slick
                    $(item).slick('setPosition');
                }
            });
        }
    }
    window.refreshCart = () => {
        fetch('/cart.js')
            .then(response => response.json())
            .then(async cartData => {
                window.__variantCompareAtMap = window.__variantCompareAtMap || {};
                const uniqueHandles = [...new Set(cartData.items.map(i => i.handle).filter(Boolean))];
                await Promise.all(uniqueHandles.map(async handle => {
                    try {
                        const res = await fetch(`/products/${handle}.js`);
                        if (!res.ok) return;
                        const prod = await res.json();
                        prod.variants.forEach(v => {
                            window.__variantCompareAtMap[v.id] = Number(v.compare_at_price || 0);
                        });
                    } catch (e) {}
                }));
                // console.log(window.cartProducts, "window.cartProducts NEW")
                let cartBubble = cartData.item_count;
                const cartBubbleElement = document.querySelector('.cart-count-bubble--value')
                if (cartBubbleElement) {
                    cartBubbleElement.innerHTML = cartBubble;
                }

                let cartWrap = document.querySelector('.mini-cart-items');
                const cartProductsDiv = document.getElementById('cart-products');
                let count = cartData.item_count;
                if (count == 0) {
                    document.querySelector('#mini-cart__wrap').classList.add('empty-cart');
                    document.querySelector('#mini-cart__wrap').classList.remove('full-cart');
                    if (document.querySelector('.empty-cart-wrap')) {
                        {
                            document.querySelector('.empty-cart-wrap').classList.remove('hidden');
                        }
                    }

                } else {
                    initAdditionalProductsOnCart()
                    document.querySelector('#mini-cart__wrap').classList.remove('empty-cart');
                    document.querySelector('#mini-cart__wrap').classList.add('full-cart');
                    if (document.querySelector('.empty-cart-wrap')) {
                        {
                            document.querySelector('.empty-cart-wrap').classList.add('hidden');
                        }
                    }
                }

                if (cartProductsDiv) {
                    cartProductsDiv.innerHTML = '';
                }
                let rightCount = 0;
                cartData.items.forEach(item => {
                    if (item.product_type != "OPTIONS_HIDDEN_PRODUCT") {
                        rightCount += 1;
                        let keys = Object.keys(item.properties);
                        const cartItemDiv = document.createElement('div');
                        cartItemDiv.classList.add('mini-cart-item');

                        const itemImg = document.createElement('div');
                        itemImg.classList.add('mini-cart-item-img');
                        const itemImgImg = document.createElement('img');
                        itemImgImg.src = item.image;
                        itemImgImg.alt = item.title;

                        const itemDetailsDiv = document.createElement('div');
                        itemDetailsDiv.classList.add('item-details');

                        const iteQtyMessage = document.createElement('span');
                        iteQtyMessage.classList.add('quantity-input-cart--error');

                        iteQtyMessage.style.display = 'none';

                        const itemName = document.createElement('div');
                        itemName.classList.add('itemName');
                        const itemNameInfo = document.createElement('div');
                        itemNameInfo.classList.add('itemName-info');
                        itemNameInfo.textContent = item.product_title;
                        itemName.appendChild(itemNameInfo);

                        const itemPrice = document.createElement('div');
                        itemPrice.classList.add('itemPrice');
                        const variantCompareAt = Number((window.__variantCompareAtMap || {})[item.variant_id] || 0);
                        const finalLinePrice = Number(item.final_line_price);
                        const formatMoneyStripped = (val) => window.Shopify.formatMoney(val).replace('.00', '');
                        itemPrice.textContent = formatMoneyStripped(finalLinePrice);

                        const itemProps = document.createElement('ul');
                        let itemPropsItem = '';

                        for (let i = 0; i < keys.length; i++) {
                            if (!keys[i].includes('_bold') && !keys[i].includes('_ZapietId')) {
                                itemPropsItem += '<li><span>' + keys[i] + ': </span><span>' + item.properties[keys[i]] + '</span></li>';
                            }
                        }

                        const iteQty = document.createElement('div');
                        iteQty.classList.add('quantity-input-cart');

                        const minusBtn = document.createElement('div');
                        minusBtn.classList.add('quantity__button--custom');
                        minusBtn.classList.add('quantity__button');
                        // minusBtn.name = 'minus';
                        minusBtn.setAttribute('action', 'minus');
                        minusBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">'
                            + '<path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>'
                            + '</svg>';



                        const qtyInput = document.createElement('input');
                        // const qtyInputWrap = document.createElement('quantity-input');
                        // qtyInputWrap.classList.add('quantity')
                        qtyInput.classList.add('quantity__input');
                        qtyInput.type = 'number';
                        qtyInput.name = 'quantity';
                        qtyInput.min = '1';
                        qtyInput.step = '1';

                        qtyInput.max = 1000;
                        qtyInput.dataset.max = 1000;

                        for (let ii = 0; ii < window.cartProducts.length; ii++) {
                            if (window.cartProducts[ii].id == item.id) {
                                if (window.cartProducts[ii].qty.toString() > 0) {
                                    qtyInput.max = window.cartProducts[ii].qty.toString();
                                    qtyInput.dataset.max = window.cartProducts[ii].qty.toString();
                                }
                            }

                        }

                        qtyInput.value = item.quantity;
                        // qtyInput.setAttribute('readonly', true);
                        qtyInput.dataset.variantId = item.key;

                        const plusBtn = document.createElement('div');
                        plusBtn.classList.add('quantity__button--custom');
                        plusBtn.classList.add('quantity__button');
                        plusBtn.setAttribute('action', 'plus');
                        plusBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">'
                            + '<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>'
                            + '</svg>';

                        for (let ii = 0; ii < window.cartProducts.length; ii++) {
                            if (window.cartProducts[ii].id == item.id) {
                                if (window.cartProducts[ii].qty.toString() === item.quantity.toString()) {
                                    // plusBtn.classList.add('disabled')
                                    // console.log('disabled plusBtn cart drawer custom js')
                                }
                            }

                        }

                        iteQty.appendChild(minusBtn);
                        iteQty.appendChild(qtyInput);
                        iteQty.appendChild(plusBtn);
                        iteQty.appendChild(iteQtyMessage);

                        const itemDetailsRemove = document.createElement('div');
                        itemDetailsRemove.classList.add('item-details-remove');
                        const removeIcon = document.createElement('span');
                        removeIcon.classList.add('remove-icon');
                        removeIcon.setAttribute('data-variantID', item.key);
                        // removeIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">\n' +
                        //     '                       <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>\n' +
                        //     '                       <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>\n' +
                        //     '                    </svg>';
                        removeIcon.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">'
                            + '<path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="black" />'
                            + '</svg>';
                        if (window.gift_cover_productId == item.id) {
                            // removeIcon.classList.add('visibility-hidden')
                        }
                        removeIcon.addEventListener('click', function () {
                            let variantId = this.getAttribute('data-variantID');
                            let updates = {};
                            updates[variantId] = 0; // Remove item by setting quantity to 0
                            fetch('/cart/update.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Requested-With': 'XMLHttpRequest'
                                },
                                body: JSON.stringify({ updates })
                            })
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error('Network response was not ok ' + response.statusText);
                                    }
                                    window.refreshCart();
                                    return response.json();
                                })
                                .catch(error => {
                                    console.error('There has been a problem with your fetch operation:', error);
                                });
                        });

                        const minusBtns = document.querySelectorAll('.quantity__button--custom[action="minus"]')

                        minusBtns.forEach((item) => {
                            item.addEventListener('click', () => {
                                // console.log(item)
                            })
                        })

                        minusBtn.addEventListener('click', function () {

                            let newQuantity = parseInt(qtyInput.value) - 1;
                            let maxVal = qtyInput.getAttribute('min');
                            // console.log('minus', newQuantity, maxVal, qtyInput)
                            if (newQuantity >= 0) {
                                qtyInput.value = newQuantity;
                                plusBtn.classList.remove('disabled');
                                setTimeout(() => {
                                    updateCartQuantity(item.key, newQuantity);
                                }, 2000);
                            }
                        });

                        plusBtn.addEventListener('click', function () {

                            let newQuantity = parseInt(qtyInput.value) + 1;
                            let maxVal = parseInt(qtyInput.getAttribute('max'));
                            // console.log(newQuantity, "newQuantity", maxVal)
                            if (newQuantity <= maxVal) {
                                // console.log(newQuantity, maxVal)
                                qtyInput.value = newQuantity;
                                setTimeout(() => {
                                    updateCartQuantity(item.key, newQuantity);
                                }, 2000);
                                if (newQuantity === maxVal) {
                                    // plusBtn.classList.add('disabled')
                                    // console.log('disabled plusBtn cart drawer custom js')
                                }
                            } else if (newQuantity > maxVal) {
                                // plusBtn.classList.add('disabled')
                                // console.log('disabled plusBtn cart drawer custom js')
                                let message;

                                if (window.Shopify.locale == 'uk') {
                                    message = "Всього " + maxVal + " в наявності";
                                } else if (window.Shopify.locale == 'ru') {
                                    message = "Всего " + maxVal + " в наличии";
                                } else {
                                    message = "Only " + maxVal + " in stock";
                                }

                                iteQtyMessage.innerHTML = message;

                                iteQtyMessage.style.display = 'block';
                                qtyInput.value = maxVal;
                                setTimeout(() => {
                                    iteQtyMessage.style.display = 'none';
                                }, 3000)

                            }
                        });

                        qtyInput.addEventListener('change', function () {
                            // console.log('qty-changed')
                            let newQuantity = parseInt(this.value);
                            let maxVal = parseInt(this.getAttribute('max'));
                            let minVal = parseInt(this.getAttribute('min'));


                            if (newQuantity.toString().includes('-')) {
                                newQuantity = parseInt(newQuantity.toString().replace('-', ''));
                                // console.log(newQuantity.toString().includes('-'), newQuantity)
                            }
                            // console.log('newQuantity: ', newQuantity)

                            if (newQuantity >= 1 && newQuantity <= maxVal) {
                                setTimeout(() => {
                                    updateCartQuantity(item.key, newQuantity);
                                }, 2000);
                            } else if (this.value > maxVal) {

                                let message;

                                if (window.Shopify.locale == 'uk') {
                                    message = "Залишилося: " + maxVal;
                                } else if (window.Shopify.locale == 'ru') {
                                    message = "Осталось: " + maxVal;
                                } else {
                                    message = "Remaining: " + maxVal;
                                }

                                iteQtyMessage.innerHTML = message;

                                iteQtyMessage.style.display = 'block';
                                qtyInput.value = maxVal;
                                setTimeout(() => {
                                    iteQtyMessage.style.display = 'none';
                                }, 3000)
                            }
                        });

                        // console.log(item);
                        const itemDetailsDivInfo = document.createElement('div');
                        itemDetailsDivInfo.classList.add('item-details-info');
                        itemDetailsDivInfo.appendChild(itemName);
                        if (item.variant_title != null) {
                            const langTitle = document.createElement('div');
                            langTitle.classList.add('product-option');
                            if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
                                for (const opt of item.options_with_values) {
                                    const dt = document.createElement('dt');
                                    dt.textContent = opt.name + ': ';
                                    const dd = document.createElement('dd');
                                    dd.textContent = opt.value;
                                    langTitle.appendChild(dt);
                                    langTitle.appendChild(dd);
                                }
                            } else {
                                const dd = document.createElement('dd');
                                dd.textContent = item.variant_title;
                                langTitle.appendChild(dd);
                            }
                            itemName.appendChild(langTitle);
                        }
                        const itemDetailsDivPrice = document.createElement('div');
                        itemDetailsDivPrice.classList.add('item-details-price');
                        const regularUnitPrice = Math.max(Number(item.original_price) || 0, variantCompareAt);
                        const finalUnitPrice = Number(item.final_price);
                        if (regularUnitPrice > finalUnitPrice) {
                            const unitOld = document.createElement('s');
                            unitOld.classList.add('cart-item__old-price');
                            unitOld.textContent = formatMoneyStripped(regularUnitPrice);
                            itemDetailsDivPrice.appendChild(unitOld);
                        } else {
                            itemDetailsDivPrice.textContent = formatMoneyStripped(finalUnitPrice);
                        }
                        itemDetailsDivInfo.appendChild(itemDetailsDivPrice);

                        const itemDetailsDivPriceEnd = document.createElement('div');
                        itemDetailsDivPriceEnd.classList.add('item-details-price-end');
                        itemDetailsDivPriceEnd.appendChild(iteQty);
                        itemDetailsDivPriceEnd.appendChild(itemPrice);
                        itemDetailsDivInfo.appendChild(itemDetailsDivPriceEnd);

                        itemDetailsDiv.appendChild(itemDetailsDivInfo);

                        itemDetailsDiv.appendChild(iteQtyMessage);
                        itemDetailsDiv.appendChild(itemProps);

                        itemProps.innerHTML = itemPropsItem;
                        cartItemDiv.appendChild(itemImg);
                        itemImg.appendChild(itemImgImg);
                        cartItemDiv.appendChild(itemDetailsDiv);
                        cartItemDiv.appendChild(itemDetailsRemove);
                        itemDetailsRemove.appendChild(removeIcon);
                        cartProductsDiv.appendChild(cartItemDiv);
                    }
                });

                const subtotalDiv = document.querySelector('.mini-cart-total');
                if (subtotalDiv) {
                    subtotalDiv.textContent = `${window.Shopify.formatMoney(cartData.total_price).replace('.00', '')}`;
                }
                if (cartWrap) {
                    cartWrap.classList.remove('loading');
                }
            })
            .catch(error => {
                console.error("Error fetching cart data:", error);
            });
    };

    const updateCartQuantity = (variantId, newQuantity) => {
        let updates = {};
        updates[variantId] = newQuantity;
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to update quantity');
                }
                window.refreshCart();
                return response.json();
            })
            .catch(error => {
                console.error('Error updating cart quantity:', error);
            });
    };


    let drawerOpenEl = document.querySelector('#mini-cart__wrap');
    let drawerOpenTrigger = document.querySelector('.header-custom__hamburger--cart');
    if (drawerOpenTrigger && drawerOpenEl) {
        drawerOpenTrigger.addEventListener('click', (e) => {
            document.body.classList.add('overflow-hidden');
            document.querySelector('html').classList.add('overflow-hidden');
            e.preventDefault();
            drawerOpenEl.classList.add('open');
            window.refreshCart();
        });
    }
    let drawerClose = document.querySelector('.mini-cart__heading--close');
    if (drawerClose && drawerOpenEl) {
        drawerClose.addEventListener('click', () => {
            drawerOpenEl.classList.remove('open');
            document.body.classList.remove('overflow-hidden');
            document.querySelector('html').classList.remove('overflow-hidden');
        });
    }

    let drawerCloseCustom = document.querySelectorAll('.custom-close-drawer');
    drawerCloseCustom.forEach((item) => {
        if (drawerCloseCustom && drawerOpenEl) {
            item.addEventListener('click', () => {
                drawerOpenEl.classList.remove('open');
                document.body.classList.remove('overflow-hidden');
                document.querySelector('html').classList.remove('overflow-hidden');
            });
        }
    })


    let relatedProductsVariantSelector = document.querySelectorAll('.additional-products-cart--variants--select');
    if (relatedProductsVariantSelector) {
        relatedProductsVariantSelector.forEach((selectedOption) => {
            selectedOption.addEventListener('change', (event) => {
                const selectedOption = event.target.selectedOptions[0];

                const variantId = selectedOption.getAttribute('data-id');
                const variantPrice = selectedOption.getAttribute('data-price');
                const variantImage = selectedOption.getAttribute('data-img');
                const variantTitle = selectedOption.value;
                const variantAvailable = selectedOption.getAttribute('data-available');


                if (!variantAvailable) {
                    selectedOption.closest('.additional-products-cart--item').querySelector('.atc-button').classList.add('unavailable')
                } else {
                    selectedOption.closest('.additional-products-cart--item').querySelector('.atc-button').classList.remove('unavailable')
                }
                selectedOption.closest('.additional-products-cart--item').querySelector('.additional-products-cart--price').innerHTML = variantPrice;
                selectedOption.closest('.additional-products-cart--item').querySelector('.additional-products-cart--img img').setAttribute('src', variantImage);

            })
        })
    }
    const variantSelects = document.querySelectorAll('.additional-products-cart--variants--select');

    variantSelects.forEach(function (select) {
        select.addEventListener('change', function () {
            const selectedOption = this.options[this.selectedIndex];
            const variantId = selectedOption.getAttribute('data-id');
            const atcButton = this.closest('.additional-products-cart--content').querySelector('.atc-button');

            atcButton.setAttribute('data-variantid', variantId);
        });
    });

    const atcButtons = document.querySelectorAll('.atc-button');

    atcButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const variantId = this.getAttribute('data-variantid');

            if (variantId) {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        // console.log('Product added to cart:', data);
                        window.refreshCart();
                    })
                    .catch(error => {
                        alert('There was an error adding the product to the cart.');
                    });
            } else {
                alert('Please select a valid variant.');
            }
        });
    });

    window.refreshCart();
});
